import {axios, API, SendRequest, toastr, WebsiteCookies} from '@/imports-files/pages/clients/jobs/new';

export class CandidateGeneralProfileService extends SendRequest 
{
  async like_dislike( params, candidate_id) 
  {
    try {
      const result = await axios.post( API.client.candidates.LIKE_CANDIDATE.replace('$candidate_id', candidate_id),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }


  async getApplicationsData( params) 
  {
    const url = API.client.applicant.CANDIDATE_INFO.replace('$application_id', params.applicant_id);
    try {
      const result = await axios.get( url,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async addNote(params, candidate_id)
  {
    try {
            const result = await axios.post( API.client.applicant.CANDIDATE_ADD_NOTE.replace('$candidate_id', candidate_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
    catch (error) {
                    return error;
                  }
  }
  async editNote(params, candidate_id, note_id)
  {
    try {
            const result = await axios.patch( API.client.applicant.UPDATE_NOTE.replace(
              "$candidate_id",
              candidate_id
            ).replace("$note_id", note_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
    catch (error) {
                    return error;
                  }
  }
  
  async shareWithNameSuggestion(params) 
  {
    try {
      const result = await axios.get( API.client.jobs.GET_CLIENT_USERS,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

}
